import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { CHAPTERS, BLUEPRINT_IMAGE } from "../data/content";

const Manifesto = () => (
  <section id="about" data-testid="manifesto-section" className="relative bg-white border-b border-slate-200">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-32">
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <motion.div
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="lg:sticky lg:top-28"
          >
            <p className="font-mono text-[10px] tracking-[0.35em] uppercase text-blueprint-accent mb-6">
              The Manifesto
            </p>
            <h2 className="font-display font-extrabold tracking-tight leading-[1.02] text-4xl md:text-5xl text-prussian">
              Why Hyderabad<br />builds with us.
            </h2>
            <p className="mt-6 text-sm md:text-base text-slate-600 leading-relaxed max-w-sm">
              Four principles. Every site. Every slab. No exceptions — that is what
              cost-effective, strong construction actually means.
            </p>
            <div className="mt-10 relative border border-blueprint-line hidden lg:block">
              <img
                src={BLUEPRINT_IMAGE}
                alt="Architectural floor plan detail"
                data-testid="manifesto-blueprint-image"
                className="w-full h-56 object-cover"
              />
              <p className="absolute bottom-2 left-3 font-mono text-[9px] tracking-[0.25em] uppercase text-white bg-prussian/80 px-2 py-1">
                Fig. 02 — Drawing Board
              </p>
            </div>
          </motion.div>
        </div>

        <div className="lg:col-span-8">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.num}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.08, duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
              data-testid={`manifesto-chapter-${c.num}`}
              className="group border-t border-slate-200 py-9 md:py-12 grid md:grid-cols-12 gap-4 md:gap-6 items-start hover:bg-blueprint-light/60 transition-colors duration-500 px-2 md:px-4"
            >
              <p className="md:col-span-2 font-mono text-sm text-blueprint-accent tracking-widest">
                / {c.num}
              </p>
              <h3 className="md:col-span-4 font-display font-bold tracking-tight text-2xl md:text-3xl text-prussian">
                {c.title}
              </h3>
              <p className="md:col-span-5 text-sm md:text-base text-slate-600 leading-relaxed">
                {c.body}
              </p>
              <div className="hidden md:flex md:col-span-1 justify-end">
                <ArrowRight
                  size={20}
                  className="text-slate-300 group-hover:text-blueprint-accent group-hover:translate-x-1.5 transition-[transform,color] duration-500"
                />
              </div>
            </motion.div>
          ))}
          <div className="border-t border-slate-200" />
        </div>
      </div>
    </div>
  </section>
);

export default Manifesto;
